
import AppSearchBrowse from "@/components/browse/SearchBrowse.vue";
import { Contact } from "@/models/base";
import { BrowseService } from "@/services/browse-service";
import { IBrowseBaseDataSource } from "@/utils/browse/browse-data-source";
import Vue from "vue";
import { ProspectService } from "@/services/prospect-service";
import { FetchedTotal } from "@/utils/views/fetched-total";
import { View } from "@/models/view";
import { HumanFilter } from "@/utils/human-filter";
import { IQueryParamsWithOptionalView } from "@/utils/query-params";
import { IGetResponse } from "@/utils/get-response";

const activeFilter = new HumanFilter({Field: "this.Active", Operator: "=", Values: ["1"]});

export default Vue.extend({
	props: {
		activeOnly: Boolean
	},
	computed: {
		dataSource():IBrowseBaseDataSource<Contact> {
			return {
				getSettings: () => BrowseService.getBrowse(3),
				getElements: (params:IQueryParamsWithOptionalView) => this.getElements(params),
				getTotals(view:View):Promise<FetchedTotal[]>{
					return ProspectService.getTotals(view);
				},
				browseName: "Prospects",
				modelName: "Contact"
			};
		}
	},
	methods: {
		getElements(params:IQueryParamsWithOptionalView):Promise<IGetResponse<Contact>> {
			return ProspectService.getContacts(params, this.activeOnly ? [activeFilter] : []);
		},
		onClick(contact:Contact) {
			this.$emit("click", contact);
		}
	},
	components: {
		AppSearchBrowse
	}
});
